import React from 'react'

import { Link } from 'react-router-dom';

const Animation = () => {

    

    return (
        <>
            <marquee behavior="scroll" scrollamount="14" bgcolor="#fdc800" height="40pxl">
                <h3> Animation Training Institute Registration Apply Easy 3 Step</h3>
            </marquee>


            <div className="slider1-area overlay-default">
                <div className="bend niceties preview-1">
                    <div id="ensign-nivoslider-3" className="slides">
                        <img src="/images/Anime_img/anime1.jpg" alt="slider" title="#slider-direction-1" />
                        <img src="/images/Anime_img/anime2.jpg" alt="slider" title="#slider-direction-2" />

                    </div>
                    <div id="slider-direction-1" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-1">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="slider-direction-2" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-2">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div className="shop-details-page-area pt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                            <div className="inner-shop-details">
                                <div className="product-details-info-area">
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                            <div className="inner-product-details-left">
                                                <div className="featured-box">
                                                    <div className="featured-img-holder hvr-bounce-to-right">
                                                        <img src="/images/image.png" className="img-responsive" alt="featured" />
                                                    </div></div>
                                            </div></div>
                                        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                            <div className="inner-product-details-right">
                                                <ul className="learning-outcomes">
                                                    <h3>Advance Diploma In 2D & 3D Animation  </h3>
                                                    <h3>Advance Diploma In 3D Film Animation</h3>
                                                    <h3>Diploma In 3D Animation</h3>
                                                    <h3>Diploma In 2D Animation</h3>
                                                    <h3>Advance Diploma In Multimedia Animation</h3>
                                                    <h3>Diploma In 3D Modeling & Texturing</h3>
                                                    <h3>Diploma In VFX (Special Effects)</h3>
                                                    <h3>Certificate In 3D Animation </h3>
                                                    <h3>Certificate In 2D Animation </h3>
                                                    <h3>Certificate In VFX</h3>
                                                </ul></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container mt-3'>
                    <h2 className='title-center pt-2'>About Animation</h2>
                    <p>With the rise of the VFX and virtual visualisation of the big screen and other entertainment industries, animation courses are a good choice. Entertainment, advertising as well as the IT industry offer amazing job opportunities to candidates who pursue animation courses.<br /><br />You might have seen movies like Kung Fu Panda, Narnia, Bolt, Ice Age, Monster vs. Aliens and many other films. These movies are an example of a miracle that is called Animation. Today, Animation Courses have a wide scope in the market, and it is an apt field for those who want to create magic and turn their imagination into a reality.<br /><br />Despite the global economic crisis in recent times, the scope for animation courses has been increasing rapidly. Even though animation courses have emerged late in India, they are witnessing a tremendous growth and the future scope is bright. Every year, thousands of aspirants are pursuing animation courses, and they are being placed in the areas of 2D & 3D Animation.<br /><br />The scope for animation courses will further increase as various animation giants like Disney are outsourcing the animation works. Therefore, choosing a career in Animation is a good choice. Following are all the details that you need to know about animation courses.</p>
                    <div className='d-flex justify-content-center p-4'>
                        <img src='/images/anime_img/anime-3.jpg' alt='anime4'></img>
                    </div>


                    <h2 className='title-center'>Skills Required for Animation Courses:</h2>
                    <ul className="learning-outcomes pb-3">
                        <li>If you have a thing for creativity, Animation is one of the best career options.</li>
                        <li>Apart from creativity, you need to have a craze towards the field.</li>
                        <li>To become a good Animator, you need to have a good imagination power as well as sketching and drawing skills.</li>
                        <li>An Animator should be able to understand and catch the expressions of not only human beings but also birds, animals, and others.</li>
                        <li>The skill of the animator lies in how he/she presents the character with appropriate expressions.</li>
                        <li>An animator should have exceptional visualization skills as well as a flair for using colours.</li>
                        <li>Dedication, hard work and patience are essential to succeed in the career.</li>
                        <li>Teamwork and communication skills are also required to achieve success.</li>
                    </ul>
                    <p>Therefore, if you have all the above skills, Animation is the best career option for you.</p>

                    <div className="row p-3">
                        <h2 className="title-center pb-2">Job Options after Animation Courses</h2>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-meetup fa-3x" aria-hidden="true"></i>
                                <h3><a href="#">Animator</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-bell-slash" aria-hidden="true" />
                                <h3><a href="#">Rigging Artist</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-cube" aria-hidden="true" />
                                <h3><a href="#">Texture Artist</a></h3>
                            </div>
                        </div>
                    </div>


                    <div className="row p-3">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-grav" aria-hidden="true" />
                                <h3><a href="#">3D/ 2D Animator</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-database" aria-hidden="true" />
                                <h3><a href="#">Rendering Artist</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-map-pin" aria-hidden="true" />
                                <h3><a href="#">Image Editor</a></h3>
                            </div>
                        </div>
                    </div>


                    <div className="row p-3">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-bolt" aria-hidden="true" />
                                <h3><a href="#">Lightning Artist</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-file-image-o" aria-hidden="true" />
                                <h3><a href="#">Key Frame Animator</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-flask" aria-hidden="true" />
                                <h3><a href="#">Digital Ink and Paint Artist</a></h3>
                            </div>
                        </div>
                    </div>



                    <div className="row p-3">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-th-large" aria-hidden="true" />
                                <h3><a href="#">Special Effect Artist</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-space-shuttle" aria-hidden="true" />
                                <h3><a href="#">Character Animator</a></h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <div className="featured-box2 hvr-bounce-to-right">
                                <i className="fa fa-hand-lizard-o" aria-hidden="true" />
                                <h3><a href="#">Compositor</a></h3>
                            </div>
                        </div>
                    </div>




                </div>
            </div>

        </>
    )
}

export default Animation;